"use client";

import { useTranslations } from "next-intl";
import type * as React from "react";
import { ConvertDialog } from "@/components/core";
import { Separator } from "@/components/ui";

export const ZeroWrappersPanel: React.FC = () => {
  const t = useTranslations("stake");
  return (
    <div className="flex flex-col gap-5 py-2">
      <p className="text-xs leading-6 text-semantic-error text-start">
        {t("modal.zeroWrappersMsg")}
      </p>
      <Separator className="bg-stroke-subtle" />
      {/* Figma node 1312:19929 — single light/white تبدیل button
          with MoneyChange icon, aligned to the start (right in RTL). */}
      <div className="flex justify-end">
        <ConvertDialog />
      </div>
    </div>
  );
};
